export default __webpack_public_path__ + "static/media/080_finish_soso.av1.e8792df7.mp4";